import { render, staticRenderFns } from "./DialogImportComponent.vue?vue&type=template&id=21025d00"
import script from "./DialogImportComponent.vue?vue&type=script&lang=js"
export * from "./DialogImportComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports